import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Downloads a PDF via blob, with smart fallback for Firefox/mobile.
 * Returns { blobUrl, filename } so callers can offer "Open" / "Copy link" fallbacks.
 */
export async function downloadClaimPdf(claimId, fileNumber, token) {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const response = await axios.get(`${API}/claims/${claimId}/pdf`, {
    responseType: "blob",
    headers,
  });

  // Extract filename
  const contentDisposition = response.headers["content-disposition"];
  let filename = `constat_${fileNumber || claimId}.pdf`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename[*]?=(?:UTF-8'')?["']?([^"';\n]+)/i);
    if (match) filename = decodeURIComponent(match[1]);
  }

  const blob = new Blob([response.data], { type: "application/pdf" });
  const blobUrl = window.URL.createObjectURL(blob);

  return { blobUrl, filename };
}

/**
 * Trigger browser download from a blob URL.
 * Returns true if the click was dispatched (not guaranteed to succeed).
 */
export function triggerBlobDownload(blobUrl, filename) {
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", filename);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  // Small delay before cleanup so the browser can start the download
  setTimeout(() => {
    link.remove();
  }, 200);
  return true;
}

/**
 * Open PDF in a new browser tab (works when download is blocked).
 */
export function openPdfInNewTab(blobUrl) {
  const newTab = window.open(blobUrl, "_blank");
  if (!newTab || newTab.closed) {
    // Popup blocked — navigate current page as last resort
    window.location.href = blobUrl;
  }
}
